import request from '@/config/axios'

const base = (userMode = false) =>
  `/bosscircle/${userMode ? 'user-news-category' : 'news-category'}`
export const getCategoryList = (publisherType: number, userMode = false) =>
  request.get({ url: `${base(userMode)}/list`, params: { publisherType } })
export const saveCategory = (data: any, userMode = false) =>
  request.post({ url: `${base(userMode)}/save`, data })
export const updateCategoryStatus = (id: number, status: number, userMode = false) =>
  request.put({ url: `${base(userMode)}/status`, params: { id, status } })
export const batchUpdateCategoryStatus = (ids: number[], status: number, userMode = false) =>
  request.put({
    url: `${base(userMode)}/batch-status`,
    params: { ids: ids.join(','), status }
  })
export const deleteCategory = (id: number, userMode = false) =>
  request.delete({ url: `${base(userMode)}/delete`, params: { id } })
export const batchDeleteCategory = (ids: number[], userMode = false) =>
  request.delete({ url: `${base(userMode)}/batch-delete`, params: { ids: ids.join(',') } })
